import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

export interface IPostResponse {
  post: IPost;
}

interface IBody{
  message: string;
}


export function usePostsRejectDraftEmphemeralHttp() {
  return usePutHttp<IBody, IPostResponse>({
    path: "/ephemeral/brand-dash/posts/:id/reject-draft",
  });
}
